<template>
   <v-snackbar
      v-for="alert in alerts"
      :key="alert.id"
      v-model="visible[alert.id]"
      :timeout="3000"
      top
      :color="alert.color"
      right
      class="alert"
      >
      {{ alert.message }}
        <template #actions>
            <v-btn text icon @click="close(alert.id)">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </template>
    </v-snackbar>
   
<div v-if="loader.loading" class="loader-overlay">
 <v-skeleton-loader :type="loader.type" class="mx-auto" height="30vh" width="70vw"></v-skeleton-loader>
</div>
 
</template>

<script setup>
import { reactive, watchEffect} from 'vue'
import { storeToRefs } from 'pinia'
import {useLoaderStore} from "@/store/loader"
const loader = useLoaderStore()
const { alerts } = storeToRefs(loader)

const visible = reactive({})
function close(id){
    visible[id] = false
    loader.removeAlert(id)
}
watchEffect(() => {
    alerts.value.forEach(alert => {
         visible[alert.id] = true
    })
})
</script>

<style scoped>
.loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.alert{
    z-index:1000
}
</style>